module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_f_albino.e1771d3c.png";